import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Flex } from '@theme-ui/components';
import { css } from '@emotion/react';

import { H2, H4 } from '@app/components/typography';
import { rem } from '@app/styles/theme/layout';

import { SerialSystemGroup } from '../helpers';
import messages from '../Success.messages';
import NativeAccess from './NativeAccess';
import ProductPortal from './ProductPortal';

const NextSteps: FC<{
  productName: string;
  orderSerialSystem?: string | null;
}> = ({ productName, orderSerialSystem = SerialSystemGroup.NATIVE }) => {
  const isOnlyItozope = orderSerialSystem === SerialSystemGroup.IZOTOPE;
  const isOnlyNative = orderSerialSystem === SerialSystemGroup.NATIVE;
  const isCombined = orderSerialSystem === SerialSystemGroup.COMBINED;

  return (
    <Flex sx={{ flexDirection: 'column' }} data-testid="order-next-steps">
      <H2
        css={css`
          margin-bottom: 1.2rem;
        `}
      >
        <FormattedMessage {...messages.nextSteps} />
      </H2>

      {isCombined && (
        <Box sx={{ marginBottom: rem(20) }}>
          <H4>
            <FormattedMessage {...messages.forIzoProducts} />
          </H4>
        </Box>
      )}

      {(isOnlyItozope || isCombined) && (
        <Box sx={{ marginBottom: rem(30) }}>
          <ProductPortal />
        </Box>
      )}

      {isCombined && (
        <Box sx={{ marginBottom: rem(20) }}>
          <H4>
            <FormattedMessage {...messages.forNativeProducts} />
          </H4>
        </Box>
      )}

      {(isOnlyNative || isCombined) && (
        <NativeAccess productName={productName} />
      )}
    </Flex>
  );
};

export default NextSteps;
